import React, { useState, useEffect } from 'react';
import { listFlaggedRatings, resolveFlaggedRating } from '../../services/adminMarketplaceService';
import ConfirmDialog from '../ui/ConfirmDialog';
import { useToast } from '../../context/ToastContext';

const FlaggedReports = () => {
  const toast = useToast();
  const [reports, setReports] = useState([]);
  const [banTarget, setBanTarget] = useState(null);
  const [banReason, setBanReason] = useState('Reported as a threat by a therapist');

  const refresh = () => listFlaggedRatings(false).then(setReports);
  useEffect(() => { refresh(); }, []);

  const confirmBan = async () => {
    await resolveFlaggedRating(banTarget, 'ban', banReason);
    setBanTarget(null);
    toast.success('Client banned');
    refresh();
  };

  const handleDismiss = async (id) => {
    await resolveFlaggedRating(id, 'dismiss');
    toast.info('Report dismissed');
    refresh();
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Flagged safety reports</h2>
      <p className="text-sm text-gray-500">
        Clients reported by a therapist as behaving in a threatening or unsafe way, awaiting review.
      </p>
      {reports.map(r => (
        <div key={r._id} className="bg-white p-4 rounded-lg shadow space-y-2 border-l-4 border-red-400">
          <p className="font-semibold">
            {r.rateeId?.firstName} {r.rateeId?.lastName} ({r.rateeId?.email}) — status: {r.rateeId?.status}
          </p>
          <p className="text-sm text-gray-600">
            Reported by: {r.raterId?.firstName} {r.raterId?.lastName} ({r.raterId?.email})
          </p>
          <p className="text-sm text-gray-600">
            Order: {r.orderId?.massageType} — {r.orderId?.scheduledDate ? new Date(r.orderId.scheduledDate).toLocaleDateString() : ''}
          </p>
          {r.comment && <p className="text-sm italic">"{r.comment}"</p>}
          <div className="flex gap-2">
            <button onClick={() => setBanTarget(r._id)} className="bg-red-600 text-white px-3 py-1.5 rounded-lg text-sm">
              Ban this client
            </button>
            <button onClick={() => handleDismiss(r._id)} className="bg-gray-200 px-3 py-1.5 rounded-lg text-sm">
              Dismiss (no action)
            </button>
          </div>
        </div>
      ))}
      {reports.length === 0 && <p className="text-gray-500">No unreviewed reports.</p>}

      <ConfirmDialog
        open={!!banTarget}
        title="Ban this client?"
        message="They will lose access to the platform immediately."
        confirmLabel="Ban client"
        danger
        reason={banReason}
        onReasonChange={setBanReason}
        reasonLabel="Ban reason (shown internally only)"
        reasonRequired
        onConfirm={confirmBan}
        onCancel={() => setBanTarget(null)}
      />
    </div>
  );
};

export default FlaggedReports;
